import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import OnBoarding from "./onBoarding";
import api from "../api/api";


const Reenroll = () => {
  const [searchParams] = useSearchParams();

  const employeeRef = searchParams.get("id");
  const emp_id = searchParams.get("emp_id");
  const orgId = searchParams.get("orgId");

  const [loading, setLoading] = useState(true);
  const [employee, setEmployee] = useState(null);
  const [error, setError] = useState(null);

  const fetchEmployee = async () => {
    try {
      setLoading(true);

      const response = await api.get("/v1/timesheets/get-employee", {
        params: {
          empid: emp_id,
          company_id:orgId,
        },
      });
if(response.status==200){
     setEmployee(response.data[0]); 
}
    
    } catch (err) {
      console.error(err);
      setError("Failed to load employee details");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (employeeRef ) {
      fetchEmployee();
    } else {
      setLoading(false);
      setError("Invalid enrollment link");
    }
  }, [employeeRef,]);

  // 🔄 Loading
  if (loading) {
    return (
      <div className="flex justify-center items-center h-[60vh]">
        <CircularProgress />
      </div>
    );
  }

  

  return (
    <OnBoarding
      employee={employee}
      employeeRef={employeeRef}
      cid={orgId}
    
    />
  );
};

export default Reenroll;
